/* istanbul ignore file */
import React from 'react';
import { usePurchaseOrderUrl } from 'domain/finance/purchaseOrder/shared/usePurchaseOrderRouting';
import { UPDATE_PURCHASE_ORDER } from 'domain/finance/purchaseOrder/usePurchaseOrderService';
import { EditButton } from 'framework/ui/ui-builder';

const EditPurchaseOrderButton = (props: any) => {
  const { getUpdateEntityUrl } = usePurchaseOrderUrl();

  return (
    <EditButton
      path={getUpdateEntityUrl}
      label="Edit"
      key="create-purchase-order"
      permissionToCheck={UPDATE_PURCHASE_ORDER}
      outline
      {...props}
    />
  );
};

export default EditPurchaseOrderButton;
